module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message",
    class: {
      reduced: _vm.message.reduced, hide: _vm.hidden, sending: _vm.message.sending
    },
    on: {
      "click": _vm.expand
    }
  }, [_c('vue-object-img', {
    attrs: {
      "object": _vm.message.sender
    }
  }), _c('small', {
    staticClass: "time",
    attrs: {
      "title": _vm._f("unixtimeTo")(_vm.message.time, 'LT')
    }
  }, [_vm._v(_vm._s(_vm._f("unixtimeTo")(_vm.message.time, 'calendar')))]), _c('h4', {
    on: {
      "click": _vm.toggleReduced
    }
  }, [_vm._v(_vm._s(_vm.message.sender.name))]), (_vm.message.reduced) ? _c('div', {
    staticClass: "body"
  }, [_vm._v(_vm._s(_vm.message.text))]) : _vm._e(), (!_vm.message.reduced) ? _c('div', {
    staticClass: "body"
  }, [_c('embed-text', [_c('mark-text', [_vm._v(_vm._s(_vm.message.text))])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-315290fb","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Conversations/Message.vue
// module id = 875
// module chunks = 13